var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoldova(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6956 1.9845C26.0663 0.713095 23.1164 -3.05176e-05 20 -3.05176e-05C16.8836 -3.05176e-05 13.9338 0.713095 11.3044 1.9845L9.56525 20L11.3044 38.0154C13.9338 39.2868 16.8836 40 20 40C23.1164 40 26.0663 39.2868 28.6956 38.0154L30.4348 20L28.6956 1.9845Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3044 1.9852C4.61453 5.22012 0 12.0708 0 20C0 27.9291 4.61453 34.7798 11.3044 38.0147V1.9852Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6957 1.9852V38.0147C35.3855 34.7798 40 27.9291 40 20C40 12.0708 35.3855 5.22012 28.6957 1.9852Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9564 15.7358H22.1738C22.1738 14.5352 21.2006 13.5619 19.9999 13.5619C18.7993 13.5619 17.826 14.5352 17.826 15.7358H13.0435C13.0435 16.9179 14.0732 17.8761 15.2552 17.8761H15.1839C15.1839 19.0583 16.1422 20.0167 17.3244 20.0167C17.3244 21.0633 18.0761 21.933 19.0689 22.119L17.3822 25.9269C18.1904 26.2554 19.0737 26.438 19.9999 26.438C20.9261 26.438 21.8095 26.2554 22.6176 25.9269L20.931 22.119C21.9238 21.933 22.6755 21.0633 22.6755 20.0167C23.8577 20.0167 24.816 19.0583 24.816 17.8761H24.7446C25.9267 17.8761 26.9564 16.9179 26.9564 15.7358V15.7358Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 18.6956L17.174 19.9999V22.6086L20 24.3477L22.8261 22.6086V19.9999L20 18.6956Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.174 17.3913H22.8261V19.9999H17.174V17.3913Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_706"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoldova);
export default __webpack_public_path__ + "static/media/moldova.c0b85d2b7f6ccf8435abf3f08e786390.svg";
export { ForwardRef as ReactComponent };